var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"lojas",attrs:{"solo":"","item-text":"name","item-value":"id","label":"Selecionar a loja","items":_vm.shops},model:{value:(_vm.shop),callback:function ($$v) {_vm.shop=$$v},expression:"shop"}})
}
var staticRenderFns = []

export { render, staticRenderFns }